import React, {Component} from 'react';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import Slider from "react-slick";

//components
import Benefit from 'containers/shared/benefit/benefit';
import DynamicLink from 'components/dynamic_link';

//functions
import {cleanUpObject, convertToSortedArray} from 'app/functions';

//assets
import './benefits-slider-new.scss';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import link_arrow from 'assets/icons/slider-arrow-blue.svg';
import circled_arrow from "assets/icons/slider_circled_arrow_button.svg";

//actions
import {setSearchFilters} from 'redux/actions';

import * as Routes from '../../../constants/routes';
import {getMediaPath} from "../../../app/functions";


class BenefitsSliderNew extends Component {

    handleCategoryClick(data) {
        if (data.searchParams !== null)
            this.props.history.push(Routes.category + '/' + data.id + '/' + data.searchParams.category);
    }

    render() {
        let device = this.props.deviceState;
        let {data} = this.props;

        let isBenefitPageSlider = this.props.isBenefitPageSlider;

        let benefits = data.benefits ? convertToSortedArray(data.benefits) : data;
        let text = this.props.translations;

        let benefitsArr = [];
        for (let id in benefits) {
            let item = benefits[id];
            benefitsArr.push(
                <Benefit data={item}
                         key={'hot-benefit-' + id}
                         className=""
                />
            );
        }
        let initSlide;
        if ((data.searchParams && data.btnText) && !isBenefitPageSlider) {
            initSlide = (Object.keys(benefitsArr).length);
        } else if ((data.link || data.btnText) && !isBenefitPageSlider) {
            initSlide = (Object.keys(benefitsArr).length - 1);
        } else {
            initSlide = (Object.keys(data.benefits).length - 1);
        }


        let slider_settings = {
            dots: false,
            arrows: false,
            autoplay: false,
            rtl: true,
            initialSlide: initSlide,
            infinite: false,
            slidesToShow: 1.3,
            slidesToScroll: 1,

        };

        let useSlider = true;

        if (device === 'mobile') {
            slider_settings.dots = true
        }

        if (device !== 'mobile' && device !== 'tablet') {
            slider_settings.arrows = true;
            slider_settings.nextArrow = <SliderArrow customClass="slider-next"/>;
            slider_settings.prevArrow = <SliderArrow customClass="slider-prev"/>;
        }
        if (device === 'tablet') {
            slider_settings.initialSlide = initSlide - 2;
            slider_settings.slidesToShow = 3;
            slider_settings.slidesToScroll = 3;
            // useSlider = initSlide > 3;
        }
        if (device === 'desktop') {
            slider_settings.initialSlide = initSlide - 3;
            slider_settings.slidesToShow = 4;
            slider_settings.slidesToScroll = 4;
            // useSlider = initSlide > 4;
        }
        if (device === 'desktop-large') {
            slider_settings.initialSlide = initSlide - 4;
            slider_settings.slidesToShow = 5;
            slider_settings.slidesToScroll = 5;
            // useSlider = initSlide >= 5;
        }


        let external_link = (data.link !== '');

        if (useSlider) {
            if (data.link && data.btnText) {
                benefitsArr.push(
                    <DynamicLink data={data.link}
                                 key={"hot-benefit-extra-card-" + benefitsArr[benefitsArr.length - 1].props.data.id}>
                        <div className='extra-card-wrapper'>
                            <div className="extra-card-text">
                                <img src={circled_arrow} alt="" className="circled-arrow-btn"/>
                                <span
                                    className="slider-extra-text">{text["slider_category_link_it_does_not_end_here"]}</span>
                                <span
                                    className="slider-extra-text-underline">{text["slider_go_to_more_benefits"]}</span>
                            </div>
                        </div>
                    </DynamicLink>
                );
            } else if (data.searchParams && data.btnText) {
                benefitsArr.push(
                    <div key={"hot-benefit-extra-card-" + benefitsArr[benefitsArr.length - 1].props.data.id}
                         className="extra-card-wrapper">
                        <div className="extra-card-text" onClick={() => this.handleCategoryClick(data)}>
                            <img src={circled_arrow} alt="" className="circled-arrow-btn"/>
                            <span
                                className="slider-extra-text">{text["slider_category_link_it_does_not_end_here"]}</span>
                            <span className="slider-extra-text-underline">{text["slider_go_to_more_benefits"]}</span>
                        </div>
                    </div>
                );
            }
        }

        const sectionId = data?.title?.split(' ')?.join('_');

        return (
            <section id={sectionId}
                     className={"benefits-slider-new " + this.props.className + (useSlider ? '' : ' no-slider')}
            >
                <div className="section-title">
                    <div className="text">{data.title}</div>
                    {!external_link && data.searchParams &&
                        <div className='link'
                             onClick={() => this.handleCategoryClick(data)}>
                            <span>{data.btnText}</span>
                        </div>
                    }
                    {(external_link && data.link) &&
                        <DynamicLink className='link' data={data.link}>
                            <span>{data.btnText}</span>
                            <img src={getMediaPath(link_arrow)} className='link-arrow' alt=""/>
                        </DynamicLink>
                    }
                </div>
                {useSlider &&
                    <Slider {...slider_settings}>
                        {benefitsArr}
                    </Slider>
                }
                {!useSlider &&
                    <div className="no-slider-container">
                        {benefitsArr}
                    </div>
                }
            </section>
        );
    }
}

function SliderArrow(props) {
    const {onClick, className} = props;
    return (
        <div className={className} onClick={onClick}>
            <img src={getMediaPath(link_arrow)} alt=""/>
        </div>
    );
}

//add GD categories and deviceState to props
const mapStateToProps = store => {
    return {
        deviceState: store.state.deviceState,
        Filters: store.state.benefitSearchFilters,
        citiesArr: store.config.citiesArr,
        Categories: cleanUpObject(store.config.categoriesArr),
        benefitTypes: store.config.BenefitTypes,
        translations: store.config.Translations,
    }
};
//map a doLgin function to props
const mapDispatchToProps = dispatch => {
    return {
        setSearchFilters: (payload) => dispatch(setSearchFilters(payload))
    }
};

//connect to redux store - maps dispatch and redux state to props
export default withRouter(connect(mapStateToProps, mapDispatchToProps, null, {pure: false})(BenefitsSliderNew));
